// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FAVORITE_USERS = "Moji ob\u013e\u00faben\u00ed";
export const HAVE_ME_AS_FAVORITE = "Maj\u00fa ma medzi ob\u013e\u00faben\u00fdmi";
export const I_AM_MEMBER_OF_GROUPS = "Patr\u00edm do skup\u00edn";
export const MORE_ABOUT_ME_MY_PRODUCTS = "Pou\u017e\u00edvam";
export const MORE_ABOUT_ME_MY_PRODUCTS_ADD_FIRST_PRODUCT = "Pridaj prv\u00fd produkt";
export const MORE_ABOUT_ME_MY_PRODUCTS_SHOW = "Zobraz pridan\u00e9 produkty";
